import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "shared/UI/Modal/Modal";
import { ReactComponent as CrossIcon } from "shared/assets/Icons/cross.svg";
import { useModalContext } from "shared/core/state/ModalContext/ModalContext";

interface InformationModalProps {
  modalId: string;
  title: string;
  trigger: (show: () => void) => ReactNode;
  children?: ReactNode | ((hide: () => void) => ReactNode);
}

export const InformationModal = ({ modalId, title, trigger, children }: InformationModalProps) => {
  const { t } = useTranslation();
  const { show, isVisible, hide } = useModalContext(modalId);

  return (
    <>
      {trigger(show)}
      {isVisible && (
        <Modal width="xs" close={hide}>
          <div data-testid="information-modal" className="text-center relative p-6">
            <button
              type="button"
              data-testid="information-modal-dismiss"
              aria-label={t("modals.dismiss")}
              onClick={hide}
              className="absolute z-10 w-4 h-4 top-4 right-4"
            >
              <CrossIcon aria-hidden className="fill-brand-grey hover:fill-brand-grey-light" />
            </button>
            <div className="space-y-6 py-6">
              <h2>{title}</h2>
              {typeof children === "function" ? children(hide) : children}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
